import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { PrintParams } from "../models/maintenance-prints-params";
import { endpointsURL } from "../constants/endpointsURL";

@Injectable({
  providedIn: "root",
})
export class PrintParamsService {
  env = environment.env;
  maintenancePrintsParamsURL = endpointsURL.maintenancePrintsParamsURL;

  constructor(private httpClient: HttpClient) {}

  public getPrintParam(): Observable<PrintParams> {
    return this.httpClient.get<PrintParams>(
      `${this.env}${this.maintenancePrintsParamsURL}`
    );
  }
  public updatePrintParam(printParams: PrintParams): Observable<PrintParams> {
    return this.httpClient.put<PrintParams>(
      `${this.env}${this.maintenancePrintsParamsURL}`,
      printParams
    );
  }
}
